// Column definitions + persistence for the 在庫一覧 (Inventory) table.
export const LS_KEY = 'mfg_inventory_cols_v1';

// order here = the default column order. fixed:true → cannot be hidden (mobile card title).
export const COLUMN_DEFS = [
  { key: 'sku', labelKey: 'mfg.item.sku', defaultOn: true },
  { key: 'name', labelKey: 'mfg.item.name', defaultOn: true, fixed: true },
  { key: 'model', labelKey: 'mfg.item.model', defaultOn: true },
  { key: 'maker_pn', labelKey: 'mfg.item.makerPn', defaultOn: false },
  { key: 'url', labelKey: 'mfg.item.datasheet', defaultOn: true, sortable: false },
  { key: 'type', labelKey: 'mfg.item.type', defaultOn: true },
  { key: 'on_hand', labelKey: 'mfg.item.onHand', defaultOn: true },
  { key: 'status', labelKey: 'mfg.cols.alert', defaultOn: true, sortable: false },
  { key: 'category', labelKey: 'mfg.item.category', defaultOn: false },
  { key: 'maker', labelKey: 'mfg.item.maker', defaultOn: false },
  { key: 'departments', labelKey: 'mfg.item.departments', defaultOn: false },
  { key: 'uom', labelKey: 'mfg.item.uom', defaultOn: false },
  { key: 'reorder_point', labelKey: 'mfg.item.reorderPoint', defaultOn: false },
  { key: 'max_stock', labelKey: 'mfg.item.maxStock', defaultOn: false },
  { key: 'cost', labelKey: 'mfg.item.cost', defaultOn: false },
  { key: 'value', labelKey: 'mfg.stats.value', defaultOn: false },
  { key: 'supplier', labelKey: 'mfg.item.supplier', defaultOn: false },
  { key: 'location', labelKey: 'mfg.item.defaultLocation', defaultOn: false },
  { key: 'barcode', labelKey: 'mfg.item.barcode', defaultOn: false },
  { key: 'lot_tracked', labelKey: 'mfg.item.lotTracked', defaultOn: false },
];

const FIXED_KEYS = new Set(COLUMN_DEFS.filter((d) => d.fixed).map((d) => d.key));
const KNOWN_KEYS = new Set(COLUMN_DEFS.map((d) => d.key));

export function defaultConfig() {
  return {
    columns: COLUMN_DEFS.map((d) => ({ key: d.key, visible: d.defaultOn })),
    sort: { key: null, dir: 'asc' },
  };
}

// Merge a saved config with the current defs so newly-added columns appear and
// removed columns drop out; keeps the user's order + visibility + default sort.
export function normalizeConfig(saved) {
  const base = defaultConfig();
  if (!saved || typeof saved !== 'object') return base;
  const savedCols = Array.isArray(saved.columns) ? saved.columns.filter((c) => c && KNOWN_KEYS.has(c.key)) : [];
  const present = new Set(savedCols.map((c) => c.key));
  COLUMN_DEFS.forEach((d) => { if (!present.has(d.key)) savedCols.push({ key: d.key, visible: d.defaultOn }); });
  savedCols.forEach((c) => { if (FIXED_KEYS.has(c.key)) c.visible = true; });
  const dir = saved.sort && saved.sort.dir === 'desc' ? 'desc' : 'asc';
  const key = saved.sort && KNOWN_KEYS.has(saved.sort.key) ? saved.sort.key : null;
  return { columns: savedCols, sort: { key, dir } };
}

export function loadConfig() {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (raw) return normalizeConfig(JSON.parse(raw));
  } catch { /* ignore */ }
  return defaultConfig();
}
